/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, List } from 'antd';
import { useNavigate } from 'react-router-dom';
import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
import { useSelector } from 'react-redux';
import { RootState } from '@app/store/store';
import { Loading } from '@app/components/common/Loading/Loading';
import { GetCampaignRules, CampaignRuleDto } from '@app/api/campaignRule.api';
import { notificationController } from '@app/controllers/notificationController';
import { useLanguage } from '@app/hooks/useLanguage';

const formatRuleText = (text: string, args: Array<string | number | null | undefined>) => {
  if (!text) return '';

  return text.replace(/\{(\d+)\}/g, (_, index) => {
    const value = args[Number(index)];
    return value === null || value === undefined ? '' : String(value);
  });
};

const PrinciplePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const voucher = useSelector((state: RootState) => state.voucherSlice.voucher);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [rules, setRules] = useState<CampaignRuleDto[]>([]);
  const { language } = useLanguage();

  const campaignId = voucher?.CampaignId;
  const limitUser = voucher?.LimitUser;
  const category = voucher?.Category;

  useEffect(() => {
    if (!voucher) {
      navigate('../');
    }
  }, [voucher, navigate]);

  useEffect(() => {
    if (!campaignId) {
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    const fetchRules = async () => {
      try {
        setIsLoading(true);
        console.log('language', language);
        const res = await GetCampaignRules(campaignId, language);
        if (cancelled) return;

        const sorted = [...(res || [])].sort((a, b) => (a.SortOrder || 0) - (b.SortOrder || 0));
        setRules(sorted);
      } catch (error) {
        if (cancelled) return;

        notificationController.error({
          message: t('Không tải được nguyên tắc đăng ký'),
        });
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchRules();

    return () => {
      cancelled = true;
    };
  }, [campaignId]);

  const displayRules = useMemo(() => {
    return (rules || []).map((x) => formatRuleText(x.Content, [limitUser])).filter((x) => !!x);
  }, [rules, limitUser]);

  const navigateToFormPage = () => {
    if (category === 'PACKAGE') {
      navigate('../package');
    } else {
      navigate('../persons');
    }
  };

  if (isLoading) return <Loading />;

  return (
    <div className="OutSide">
      <Auth.FormWrapper>
        <Auth.FormTitle>{t('NGUYÊN TẮC ĐĂNG KÝ THÀNH VIÊN')}</Auth.FormTitle>

        <Auth.LoginDescription style={{ backgroundColor: 'white', padding: '10px', marginBottom: '5px' }}>
          <List
            dataSource={displayRules}
            renderItem={(item, index) => (
              <List.Item key={index} className="principle">
                {item}
              </List.Item>
            )}
          />
        </Auth.LoginDescription>

        <div style={{ justifyContent: 'center', display: 'flex' }}>
          <Button type="primary" onClick={navigateToFormPage} style={{ alignItems: 'center' }}>
            {t('Tiếp tục')}
          </Button>
        </div>
      </Auth.FormWrapper>
    </div>
  );
};

export default PrinciplePage;
